import { storeCreator } from '@/utils/store/store.utils';

interface State {
  highlightedIds: string[];
  setHighlightedIds: (ids: string[]) => void;
}

const useStore = storeCreator<State>((set) => ({
  highlightedIds: [],
  setHighlightedIds: (ids: string[]) => set((data) => ({ ...data, highlightedIds: ids })),
}));

export default useStore;
